import React from 'react'

const TopBar = () => {
  return (
    <div>
        <div className="w-full h-2 overflow-visible animate-gradientX bg-[linear-gradient(90deg,_#ff005a,_#fffa00,_#00ff85,_#00cfff,_#ff005a)] bg-[length:300%_100%] shadow-[0_-8px_20px_5px_rgba(255,0,255,0.3)]" />   
    </div>
  )
}

export default TopBar
